/**
 * Generated runtime TestId mirror for frontend/src/pages/Profile.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ProfileTestIds = {
  btnLogout: "btn-logout",
  btnTogglePermissions: "btn-toggle-permissions",
  cardTitleRolesPermissions: "card-title-roles-permissions",
  cardTitleSessionInfo: "card-title-session-info",
  colResource: "col-resource",
  inputFilterPermissions: "input-filter-permissions",
  linkIdentityDetails: "link-identity-details",
  sectionBasicInfo: "section-basic-info",
  sectionIamIdentity: "section-iam-identity",
  colAction: (action: string) => `col-action-${action}`,
  colActionPrefix: () => "col-action-" as TestIdPrefix
} as const;
